import { State } from './store';

export enum StepType {
  NewDeviceCheck = 'NewDeviceCheck',
  OldDeviceModel = 'OldDeviceModel',
  OldDeviceStatus = 'OldDeviceStatus',
  Details = 'Details',
  Confirmation = 'Confirmation',
}

export enum Page {
  Home = 'home',
  HowItWorks = 'how-it-works',
  ContactUs = 'contact-us',
  QualifyingDevices = 'qualifying-devices',
  FAQ = 'faq',
  TermsAndConditions = 'terms-and-conditions',
  Steps = 'steps',
}

export enum PromotionPhase {
  PreStart = 'pre-start',
  OnGoing = 'on-going',
  End = 'end',
}

export type PurchasedPhone = string;

interface SelectOption {
  value: string;
  label: string;
}

export interface Vendor extends SelectOption {}

export interface PhoneModel extends SelectOption {
  priceMin: string;
  priceMax: string;
  pricePromo: string | null;
}

export interface Country extends SelectOption {}

export interface County extends SelectOption {}

export interface Retailer extends SelectOption {}

export interface PhoneData {
  id: number;
  bad_nid: string;
  bad_price: string;
  check_network_unlocked: number;
  good_nid: string;
  good_price: string;
  promo_price: string | null;
  model: string;
  product_line: string;
  vendor: string;
}

export type StepValidationMap<T = boolean> = Record<Partial<StepType>, T>;

export interface ContactDetails {
  site: string;
  name: string;
  email: string;
  phone: string;
  message: string;
  g_recaptcha_response?: string[];
}

export interface ContactUsResponse {
  message: string;
  errors?: Record<keyof ContactDetails, string[]>;
  exception?: string; // Works only in DEV mode... Not actual for PROD.
  responseStatus: number;
}

interface ImeiFields {
  imei: string;
  retailer: string;
  retailerOther: string;
  purchaseConfirmation: string;
  purchased_date: string;
  g_recaptcha_response?: string[];
}

export interface ImeiValidateResponse {
  message: boolean | string;
  data: {
    full_name: string;
    alias: string;
    image_path: string;
    promo_price: string;
    promo_price_enhancement: string;
  };
  errors?: Record<keyof ImeiFields, string[]>;
  exception?: string; // Works only in DEV mode... Not actual for PROD.
  responseStatus: number;
}

export interface PlaceOrderResponse {
  success: boolean;
  order_number?: string;
  message?: string;
  errors?: Record<string, string[]>;
  exception?: string; // Works only in DEV mode... Not actual for PROD.
  responseStatus: number;
}

export interface ConfirmProps {
  name: keyof State;
  text: string;
  value: boolean;
  isRequired?: true;
}

export interface PromoDeviceProps {
  full_name: string;
  alias: string;
  image_path: string;
  promo_price: string;
  promo_price_enhancement: string;
}

export interface PromoEvents {
  is_active: boolean;
  is_transactional: boolean;
  is_enhancement_active: boolean;
  is_eligible_devices_enhancement_active: boolean;
  purchase_date_period: {
    start: string;
    end: string;
  };
  promotion_date_period: {
    start: string;
    end: string;
  };
  claim_date_period: {
    start: string;
    end: string;
  };
}
